import ColumnChartBlock from './ColumnChartBlock';

export default ColumnChartBlock;
